module.exports = __webpack_public_path__ + "static/rundle2-eee97a4443e836e37fb24734de428988.png";